import React from 'react';
export function ProblemaRealSection() {
  return <section className="bg-[#F5F5F5] py-16 md:py-24 px-4" data-id="element-109">
      <div className="max-w-4xl mx-auto text-center md:text-left space-y-8" data-id="element-110">
        <div className="space-y-4 text-xl text-gray-700 max-w-2xl mx-auto md:mx-0" data-id="element-111">
          <p data-id="element-112">Muchos vendedores viven ocupados.</p>
          <br data-id="element-113" />
          <p data-id="element-114">Pero estar ocupado no genera crecimiento.</p>
          <br data-id="element-115" />
          <p data-id="element-116">Cuando tu día se llena de tareas que no construyen tu negocio…</p>
          <br data-id="element-117" />
          <p data-id="element-118">aparece algo peligroso:</p>
        </div>

        <div className="bg-white border-l-4 border-[#FF6B00] p-8 shadow-sm rounded-r-xl my-12 max-w-3xl mx-auto" data-id="element-119">
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 text-center" data-id="element-120">
            El techo invisible de resultados
          </h3>
        </div>

        <div className="space-y-4 text-xl text-gray-700 max-w-2xl mx-auto md:mx-0" data-id="element-121">
          <p data-id="element-122">Trabajas más.</p>
          <br data-id="element-123" />
          <p data-id="element-124">Pero tu negocio crece menos de lo que podría.</p>
        </div>
      </div>
    </section>;
}